import { useMemo } from "react";

import { useOraclePrices, useSwapRoutes, useTokenListContext } from "@bridgesplit/abf-react";
import { maxSwapRouteMinInputUsd, SwapRouteMinInputUsd } from "app/utils/domain/swap-routes";

/**
 * Data-driven per-deposit minimum for the wind flow, from configured swap routes into the loop
 * collateral (e.g. Glow vault). Undefined when no configured route declares a minimum.
 */
export function useWindMinDepositView(collateralMint: string | undefined): SwapRouteMinInputUsd | undefined {
    const { atomicRoutes } = useSwapRoutes({ outputMint: collateralMint });
    const { getMetadata } = useTokenListContext();

    // Oracle prices for every min-bearing step input, gathered up front for the valuation below.
    const minStepMints = useMemo(
        () =>
            atomicRoutes?.flatMap((route) =>
                route.steps.filter((step) => step.minInputAmount).map((step) => step.inputMint)
            ),
        [atomicRoutes]
    );
    const { getUsdPrice } = useOraclePrices(minStepMints);

    return useMemo(
        () => maxSwapRouteMinInputUsd(atomicRoutes, getMetadata, getUsdPrice),
        [atomicRoutes, getMetadata, getUsdPrice]
    );
}
